module.exports = __webpack_public_path__ + "img/hero-vs_fwt21.67967ca.jpg";